import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { STATIC_CONTENT } from "@/pages/staticContent";

export default function StaticPage({ slug }) {
  const data = STATIC_CONTENT[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
    window.lenis?.scrollTo(0, { immediate: true });
  }, [slug]);

  return (
    <div className="min-h-screen bg-sand" data-testid={`static-page-${slug}`}>
      <Header />
      <main className="mx-auto max-w-3xl px-6 pb-24 pt-32 md:px-12 md:pt-40">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-medium text-graphite transition-colors hover:text-ink"
          onClick={() => window.scrollTo(0, 0)}
          data-testid="back-home"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <h1 className="mt-8 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          {data.title}
        </h1>
        <p className="mt-5 text-lg leading-relaxed text-graphite">{data.intro}</p>

        <div className="mt-12 space-y-10">
          {data.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-xl font-medium tracking-tight text-ink">
                {s.heading}
              </h2>
              {s.body.map((p, i) => (
                <p key={i} className="mt-3 leading-relaxed text-graphite">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
